import React from 'react'

interface IActionBanner {
  message: string
  icon: JSX.Element
  className: string
  handleIconClick?: () => void
}

const ActionBanner = ({
  message,
  icon,
  className,
  handleIconClick,
}: IActionBanner) => (
  <div
    className={`c-common-banner c-common-banner--action ${className}`}
    role='status'
  >
    <div className='c-common-banner__inner'>
      <span className='c-common-banner__message'>{message}</span>
      <span className='c-common-banner__icon'>
        <button
          type='button'
          onClick={handleIconClick}
          className='c-banner-icon-button'
        >
          {icon}
        </button>
      </span>
    </div>
  </div>
)

export default ActionBanner
